import type { TimelineEntry } from '../types/historyEvent';
import { isDraftGroup } from '../types/historyEvent';
import { DraftGroupItem } from './DraftGroupItem';
import { TimelineItem } from './TimelineItem';
import styles from './ReportHistoryRail.module.css';

interface ReportHistoryRailProps {
  entries: TimelineEntry[];
  selectedEventId: string | null;
  onSelectEvent: (id: string) => void;
  expandedGroupIds: Set<string>;
  onToggleGroup: (id: string) => void;
}

export default function ReportHistoryRail({
  entries,
  selectedEventId,
  onSelectEvent,
  expandedGroupIds,
  onToggleGroup,
}: ReportHistoryRailProps) {
  if (!entries.length) {
    return (
      <div className={styles.rail}>
        <p className={styles.empty}>No history yet.</p>
      </div>
    );
  }

  return (
    <div className={styles.rail}>
      <div className={styles.timeline}>
        {entries.map((entry) =>
          isDraftGroup(entry) ? (
            <DraftGroupItem
              key={entry.id}
              group={entry}
              isExpanded={expandedGroupIds.has(entry.id)}
              onToggle={() => onToggleGroup(entry.id)}
              selectedEventId={selectedEventId}
              onSelectEvent={onSelectEvent}
            />
          ) : (
            <TimelineItem
              key={entry.id}
              event={entry}
              isSelected={selectedEventId === entry.id}
              onSelect={onSelectEvent}
            />
          )
        )}
      </div>
    </div>
  );
}
